

exports.__esModule = true;
exports.$xoSepaPageComponent = undefined;

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _checkout = require('xo-models/src/checkout');

require('xo-page-components/src/value-props/directive');

require('xo-return-to-merchant/dist/util');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSepaPageComponent = exports.$xoSepaPageComponent = _squid.$Component.extend('$xoSepaPageComponent', {
    tag: 'xo-sepa-page',
    template: _template2['default'],

    scope: {
        token: '=?'
    },

    controller: ['$scope', function ($scope) {
        $scope.callbacks = {
            success: function success(sepaModel) {

                (0, _squid.$populate)($scope, {
                    checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
                    checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
                }).then(function () {
                    return sepaModel.action('clearSepa', {
                        data: {
                            bank: {
                                id: sepaModel.bankId
                            },
                            token: $scope.token
                        },

                        success: function success() {
                            $scope.checkoutSession.action('authorize', {
                                success: function success() {
                                    // xchild = V4 Incontext Integration. Do not initiate Payment.
                                    if (!window.xchild && $scope.checkoutAppData.doec_on_approve()) {
                                        return _uiRouter.$state.go('checkout.pay');
                                    }
                                    _uiRouter.$state.go('checkout.end');
                                }

                            });
                        }

                    });
                });
            }
        };
        _uiRouter.$state.go('checkout.sepapage.membersepa.sepaAgreement');
    }]

});

angular.value("$xoSepaPageComponent", $xoSepaPageComponent);
_squid.$Component;

_squid.$populate;

_uiRouter.$state;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sepa/directive.js
// module id = ./pages/xo-sepa/directive.js
// module chunks = 0